/**
 * 安全工具函数
 */
import CryptoJS from 'crypto-js'

const SECRET_KEY = '12345678901234567890123456789012'
const SECRET_IV = '1234567890123456'

export function encryptData(data) {
  try {
    const stringData = typeof data === 'string' ? data : JSON.stringify(data)
    const key = CryptoJS.enc.Utf8.parse(SECRET_KEY)
    const iv = CryptoJS.enc.Utf8.parse(SECRET_IV)
    const encrypted = CryptoJS.AES.encrypt(stringData, key, {
      iv: iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7
    })
    return encrypted.toString()
  } catch (error) {
    safeLog('加密失败:', error)
    return data
  }
}

export function decryptData(encryptedData) {
  try {
    const key = CryptoJS.enc.Utf8.parse(SECRET_KEY)
    const iv = CryptoJS.enc.Utf8.parse(SECRET_IV)
    const decrypted = CryptoJS.AES.decrypt(encryptedData, key, {
      iv: iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7
    })
    const decryptedString = decrypted.toString(CryptoJS.enc.Utf8)
    try {
      return JSON.parse(decryptedString)
    } catch {
      return decryptedString
    }
  } catch (error) {
    safeLog('解密失败:', error)
    return encryptedData
  }
}

export function isEncryptedData(data) {
  if (typeof data !== 'string') return false
  try {
    const key = CryptoJS.enc.Utf8.parse(SECRET_KEY)
    const iv = CryptoJS.enc.Utf8.parse(SECRET_IV)
    CryptoJS.AES.decrypt(data, key, {
      iv: iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7
    }).toString(CryptoJS.enc.Utf8)
    return true
  } catch {
    return false
  }
}

export function sanitizeHTML(html) {
  if (!html || typeof html !== 'string') return ''
  
  const div = document.createElement('div')
  div.textContent = html
  return div.innerHTML
}

export function escapeXSS(str) {
  if (!str || typeof str !== 'string') return str
  
  return str
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#x27;')
    .replace(/\//g, '&#x2F;')
    .replace(/javascript:/gi, '')
    .replace(/on\w+=/gi, '')
}

export function validatePhone(phone) {
  if (!phone) return false
  return /^1[3-9]\d{9}$/.test(String(phone))
}

export function validateIdCard(idCard) {
  if (!idCard) return false
  const reg = /^[1-9]\d{5}(18|19|20)\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/
  return reg.test(String(idCard))
}

export function validateAmount(amount) {
  if (!amount) return false
  const num = parseFloat(amount)
  return !isNaN(num) && num >= 0 && num <= 999999999.99
}

export function sanitizeInput(input, maxLength = 100) {
  if (!input) return ''
  let str = String(input).trim()
  if (maxLength > 0) {
    str = str.substring(0, maxLength)
  }
  return escapeXSS(str)
}

export function maskPhone(phone) {
  if (!phone) return ''
  const str = String(phone)
  if (str.length < 11) return str
  return str.replace(/(\d{3})\d{4}(\d{4})/, '$1****$2')
}

export function maskIdCard(idCard) {
  if (!idCard) return ''
  const str = String(idCard)
  if (str.length < 8) return str
  return str.substring(0, 4) + '********' + str.substring(str.length - 4)
}

export function maskName(name) {
  if (!name) return ''
  const str = String(name)
  if (str.length <= 1) return str
  if (str.length === 2) return str[0] + '*'
  return str[0] + '*'.repeat(str.length - 2) + str[str.length - 1]
}

export function generateNonce() {
  return Date.now().toString(36) + Math.random().toString(36).substring(2, 10)
}

let csrfToken = null

export function setCsrfToken(token) {
  csrfToken = token
}

export function getCsrfToken() {
  if (!csrfToken) {
    csrfToken = generateNonce()
  }
  return csrfToken
}

export function isValidJSON(str) {
  try {
    JSON.parse(str)
    return true
  } catch (e) {
    return false
  }
}

export function deepClone(obj) {
  if (obj === null || typeof obj !== 'object') return obj
  if (obj instanceof Date) return new Date(obj.getTime())
  if (obj instanceof Array) return obj.map(item => deepClone(item))
  if (obj instanceof Object) {
    const cloned = {}
    for (const key in obj) {
      if (obj.hasOwnProperty(key)) {
        cloned[key] = deepClone(obj[key])
      }
    }
    return cloned
  }
  return obj
}

const SENSITIVE_KEYS = ['password', 'token', 'secret', 'key', 'credit', 'card']

export function filterSensitiveData(data, depth = 0) {
  if (depth > 3) return '[TooDeep]'
  
  if (data === null || data === undefined) return data
  if (typeof data === 'string') {
    const lower = data.toLowerCase()
    if (SENSITIVE_KEYS.some(key => lower.includes(key))) {
      return '[Sensitive]'
    }
    return data
  }
  if (typeof data !== 'object') return data
  
  if (Array.isArray(data)) {
    return data.map(item => filterSensitiveData(item, depth + 1))
  }
  
  const result = {}
  for (const key in data) {
    if (data.hasOwnProperty(key)) {
      const lowerKey = key.toLowerCase()
      if (SENSITIVE_KEYS.some(sensitive => lowerKey.includes(sensitive))) {
        result[key] = '[Filtered]'
      } else {
        result[key] = filterSensitiveData(data[key], depth + 1)
      }
    }
  }
  return result
}

export function safeLog(...args) {
}

export function recordError(error, context = '') {
}
